$(".js-form-demo").on("click", function() {
  $("[data-demo]").each(function() {
    $(this).val($(this).data("demo")).trigger("change");
  });
  $(".business-time-show").prop("checked", true);
  $(".js-business_time-ok").click();
  $(".js-button-accordion2").click();
});

function drawMap(address) {
  var geocoder = new google.maps.Geocoder();

  geocoder.geocode({
    address: address,
    region: "jp"
  }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      var map_tag = document.getElementById("map");
      var map_location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());

      var map_options = {
        zoom: 18,
        center: map_location,
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      var map = new google.maps.Map(map_tag, map_options);

      var marker = new google.maps.Marker({position: map_location, map: map});

      $("#address1,#address2").on("blur", function() {
        var state = $("#state").val();
        var city = $("#city").val();
        var address1 = $("#address1").val();
        var address2 = " " + $("#address2").val();
        var address = state + city + address1 + address2;
        redrawmap(map, marker, address);
      });
    }
  });
}

function redrawmap(_map, _marker, _address) {
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    address: _address,
    region: "jp"
  }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      var map_tag = document.getElementById("map");
      var map_location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
      _map.panTo(map_location);
      _marker.setPosition(map_location);
    }
  });
}


var geocode = function(address) {

  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    address: address,
    region: 'JP',
    newForwardGeocoder: true
  }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {

      var $cities = $("#city");
      var $prefecture = $("#state");
      var $address = $("#address1");
      var $buildings = $("#address2");
      $cities.val('');
      $prefecture.val('');
      $address.val('');
      $buildings.val('');
      var obj = results[0].address_components;
      for(var address, oldSublocality, idx = obj.length - 1; address = obj[idx]; idx--) {
        var type = address.types[0];
        // "postal_code":郵便番号
        // "administrative_area_level_1": 都道府県
        // "locality": 市町村
        // "political":丁目,("sublocality_level_4-6":号)
        // "premise"：ビル
        if (type === 'locality') {
          $cities.val($cities.val() + address.long_name);
        } else if (type === 'political') {
          var sublocality = address.types[address.types.length - 1];
          if ((sublocality === 'sublocality_level_4' && oldSublocality === 'sublocality_level_3') ||
              (sublocality === 'sublocality_level_5' && oldSublocality === 'sublocality_level_4') ||
              (sublocality === 'sublocality_level_6' && oldSublocality === 'sublocality_level_5')) {
            // 番地の後号が続く場合、数値がつながらないようにする（２－２が２２とならないよう）
            $address.val($address.val() + '－' + address.long_name);
          } else {
            $address.val($address.val() + address.long_name);
          }
          oldSublocality = sublocality;
        } else if (type === 'administrative_area_level_1') {
          $prefecture.val( $prefecture.val() + address.long_name);
        } else if (type === 'postal_code') {
          // $postalcode.val($postalcode.val() + address.long_name);
        } else if (type === 'premise') {
          $buildings.val($buildings.val() + address.long_name);
        }
      }

      
      // if (obj.length < 5) {
      //   return false;
      // }

      // var state = obj[2]["long_name"];
      // var city = obj[1]["long_name"];
      // var address1 = obj[1]["long_name"];

      // $("#state").val(state); // 都道府県
      // $("#city").val(city); // 市区町村
      // if (!$("#address1").val()) {
      //   $("#address1").val(address1); // 町名
      // }

      // buttonActive();
      // drawMap(state + city);
      getMapAddress();

    }else{
      buttonActive();
          return false;
    }

  });
};

function setState() {
  var zip = $("#zip").val();
  // zipのバリデーション
  if (zip.match(/^\d{3}-?\d{4}$/)) {
    if (zip.match(/^\d{7}/)) {
      zip = zip.slice(0, 3) + "-" + zip.slice(3);
      $("#zip").val(zip);
    }
    geocode(zip);
  }
}

function getMapAddress() {
  var state = $("#state").val();
  var city = $("#city").val();
  var address1 = $("#address1").val();
  buttonActive();
  drawMap(state + city + address1);
}

function buttonActive() {
  $(".hide").removeClass("hide");
  checkRequired();
}

function checkRequired() {
  var count = 0;
  $(":input[required]:visible").each(function() {
    if ($(this).val() == "") {
      count++;
    }
  });
  if (count == 0) {
    unlockButton();
  } else {
    lockButton();
  }
}

function lockButton() {
  $("#js-form-button").prop("disabled", true);
  $("#js-form-button").addClass("button-form--disabled");
  $("#js-form-button").removeClass("button-form--primary");
  var text = $("#js-form-button").data("lock");
  $("#js-form-button").text(text);
}

function unlockButton() {
  $("#js-form-button").prop("disabled", false);
  $("#js-form-button").removeClass("button-form--disabled");
  $("#js-form-button").addClass("button-form--primary");
  var text = $("#js-form-button").data("unlock");
  $("#js-form-button").text(text);
}

//////////////////////////
// 営業曜日
//////////////////////////

function BusinessTime() {
  var myself = this;
  this.checkbox = '#js-business_time-detail input[type="checkbox"]';

  $(document).on("click", "#js-business_time-trigger", function() {
    myself.check(myself);
  });

  $(document).on("click", myself.checkbox, function() {
    var target = $(this).parent().parent().find('input[type="time"]');
    if ($(this).is(":checked")) {
      target.prop("disabled", false);
    } else {
      target.prop("disabled", true);
    }
  });

  $(document).on("click", ".js-business_time-ok", function() {
    hideModal();
    $("#business-time-show").prop("checked", true);
    myself.isChecked(myself);
  });

  $(document).on("click", ".js-business_time-no", function() {
    $("#business-time-show").prop("checked", false);
    myself.isChecked(myself);
  });

  $(document).on("change", ".js-business_time-start", function() {
    let ele = $(this);
    ele.parent().parent().toggleClass("empty", !ele.val());
  });

  this.isChecked(this);
}

BusinessTime.prototype.check = function(_myself) {
  if ($("#js-business_time-detail").hasClass("mode-detail")) {
    $("#js-business_time-detail").removeClass("mode-detail");
    $(".js-business_time-hide").show();
  } else {
    $("#js-business_time-detail").addClass("mode-detail");
    $(".js-business_time-hide").hide();
  }

  if (!$("#business-time-show").prop("checked")) {
    // 初回のみコピーする
    _myself.basicStart = $(".js-business_time-basic-start").eq(0).val();
    _myself.basicEnd = $(".js-business_time-basic-end").eq(0).val();

    $(_myself.checkbox).each(function(index) {
      if ($(this).is(":checked")) {
        $(".js-business_time-start").eq(index).val(_myself.basicStart);
        $(".js-business_time-end").eq(index).val(_myself.basicEnd);
      }
    });
  }

  //
};

BusinessTime.prototype.isChecked = function(_myself) {
  var checked = $("#business-time-show").is(":checked");
  if (checked) {
    $("#js-business_hours-button").hide();
    $("#js-business_hours-textbox").show();
    _myself.display(_myself);
  } else {
    $("#js-business_hours-button").show();
    $("#js-business_hours-textbox").hide();
  }
};

BusinessTime.prototype.display = function(_myself) {
  // 曜日毎フラグ
  let dayOfWeek = $("#business-time-iscustom").is(":checked");

  // 定休日のリスト
  let closeDays = function() {
    let days = [];
    $("#js-business_time-detail li").each(function() {
      let day = $(this).find('input[type="checkbox"]').next().text();
      let open = $(this).find('input[type="checkbox"]').is(":checked");
      if (!open) {
        days.push(day);
      }
    });
    return days;
  };

  // 営業時間表記変換
  let businessHour = function(li) {
    let hours = [];
    li.find(".js-business_time-time").each(function() {
      let hour = $(this);
      let start = hour.find('input[type="time"]:first');
      if (!start.val()) {
        return;
      }
      let end = hour.find('input[type="time"]:last');
      hours.push(start.val() + "〜" + end.val());
    });

    if (hours.length) {
      return hours.join(" / ");
    } else {
      return "通常営業";
    }
  };

  // 全曜日の営業時間表記
  let allBusinessHours = function(ele) {
    let hours = [];
    ele.find("li").each(function() {
      let li = $(this);
      let day = li.find('input[type="checkbox"]').next().text();
      let open = li.find('input[type="checkbox"]').is(":checked");
      if (open) {
        hours.push(day + " " + businessHour(li));
      } else {
        hours.push(day + " 定休日");
      }
    });
    return hours;
  };

  let html = "";
  if (dayOfWeek) {
    html = allBusinessHours($("#js-business_time-detail")).join("<br>");
  } else {
    html = "営業時間：" + businessHour($("#js-business_time-basic")) + "<br>定休日：" + closeDays().join("");
  }

  let option = $("#js-business_time-option").val();
  if (option) {
    html += "<br>" + option;
  }

  $("#js-business_hours-text").html(html);
  $("#js-business_hours-textbox").show();
};

function hideModal() {
  // $('.modal.show').fadeOut(150);
  $('#js-modal-bg').fadeOut(150);
  $('.modal').removeClass('show2');
  $('.modal').removeClass('show');
  // setTimeout(function(){
  //   $(_target).removeClass('show');
  // },150);
}

// $(document).on("click", ".js-duplicate-delete", duplicateDelete);]

if ($("#zip").length > 0) {
  $("#zip").on("change keydown keyup paste", setState);

  if ($("#zip").val() != "") {
    getMapAddress();
  }


  var bt = new BusinessTime();

  $(":input[required]:visible").on("blur", function() {
    checkRequired();
  });
}
